<template>
    <td-dialog :title="title" :before-close="moduleDialogClose" :visible.sync="dialogModuleVisible" width="32%" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formModuleInfo" ref="formModuleInfo" :rules="rules">
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.MODULENAME')" :label-width="formLabelWidth" prop="sName">
                        <td-input v-model="formModuleInfo.sName" :maxlength="10"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item :label="$t('common.ORDER')" :label-width="formLabelWidth" prop="iOrder">
                        <!-- <td-input v-model="formModuleInfo.iOrder" ></td-input> -->
                        <td-input-number v-model="formModuleInfo.iOrder" :min="1"></td-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formModuleInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="moduleDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from '../assets/api.js';
export default {
    props: ['title', 'dialogModuleVisible', 'moduleItem', 'isAddModule', 'moudleData', 'sysFlg', 'maxModuleOrder'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddModule) {
            this.initEditData();
        } else {
            // 默认新增排序字段为当前数据库中最大的排序字段值
            this.formModuleInfo.iOrder = this.maxModuleOrder;
        }
    },
    // 定义变量
    data() {
        return {
            // Module表单信息
            formModuleInfo: {
                sId: '',
                sName: '',
                iOrder: '',
                sSysFlg: ''
            },
            loading: false,
            formLabelWidth: '30%',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_CAPTION_ILLEGAL')
                    }
                ],
                iOrder: [
                    { required: true, message: this.$t('error.ERROR_ORDER_NULL'), trigger: 'blur' }
                    // ,
                    // { pattern: this.$regex.ORDER_RULE,
                    //     message: this.$t('error.ERROR_ORDER_ILLEGAL')}
                ]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formModuleInfo.sName = this.moduleItem.sModuleName;
            this.formModuleInfo.sId = this.moduleItem.sId;
            this.formModuleInfo.iOrder = this.moduleItem.iOrder;
        },
        checkChange(item, node, self) {
            if (node === true) {
                // 点击未选中复选框
                this.editCheckId = item.sId;
                this.$refs.tree.setCheckedKeys([item.sId]);
            } else {
                if (this.editCheckId === item.sId) {
                    // 点击已选中复选框，保证至少一个选中
                    this.$refs.tree.setCheckedKeys([item.sId]);
                }
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                // console.log(formName)
                // return
                if (valid) {
                    this.loading = true;
                    let content = {
                        sModuleName: this.formModuleInfo.sName,
                        iOrder: this.formModuleInfo.iOrder,
                        sSysFlg: this.sysFlg
                    };
                    let successMsg = this.$t('common.ADD_SUCCESS');
                    if (!this.isAddModule) {
                        content.sid = this.moduleItem.sId;
                        successMsg = this.$t('common.MODIFY_SUCCESS');
                    }
                    resourceApi.insertModuleInfo(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extend/insertModuleInfo', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: successMsg, type: 'success' });
                        this.moduleDialogClose();
                        this.$emit('submit');
                        this.$emit('refreshModule');
                    });
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        moduleDialogClose() {
            this.$emit('moduleDialogClose');
            this.$refs['formModuleInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
